import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialogRef } from '@angular/material/dialog';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-subject-change',
  templateUrl: './subject-change.component.html',
  styleUrls: ['./subject-change.component.scss']
})
export class SubjectChangeComponent implements OnInit {
  SubChgForm: FormGroup;
  filteredDataList: any;
  DataList: any;
  dialogRef: MatDialogRef<any>;
  submitpayload: any;
  listdesc: any;
  clgname: any;
  submitButton = true;
  editButton = false;
  deleteButton = false;
  SessionNo: any;
  subChgList: any[];
  List: any;
  APIService: any;
  collegeList: any;
  filteredCollegeList: any;
  constructor(public umsService: UmsService,private spinner:NgxSpinnerService,
    private modalPopupService: ModalpopService,
    // private dialogRef2:MatDialogRef<SubjectChangeComponent>,
    public fb: FormBuilder,
    private httpClient: HttpClient,) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
      this.getExmFrmList(this.SessionNo);
    }
    this.submitButton = true;
    this.editButton = false;
    this.deleteButton = false;
    this.SubChgForm = this.fb.group({
      // SubChglistNo: new FormControl(),
      EcId: new FormControl(),
      SubChglistNo2: new FormControl(),
      SubChglistNo3: new FormControl('New'),
      SubChgClg: new FormControl(),
      SubChgValid: new FormControl(),
      SubChgChng: new FormControl(),
      // SubChgBatch: new FormControl(),
      Batch: new FormControl(),
      // SubChgRollNo: new FormControl(),
      RollNo: new FormControl(),
      RgNo: new FormControl(),
      SubChgName: new FormControl(),
      SubChgValid2: new FormControl(),
      SubChgValid3: new FormControl(),
     } );

    this.getCollegeData();
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      this.getExmFrmList(this.SessionNo);
      }
    );
  }

  deletee(e, k){
    if (e === 'true'){
      
      this.prepopulationForDelete(k);
    } else {
      
    }
  }

  prepopulationForDelete(data){
    this.editButton = false;
    this.submitButton = false;
    this.deleteButton = true;
    this.SubChgForm = this.fb.group({
      EcId: new FormControl(data.EcId),
      Batch: new FormControl(data.Batch),
      RgNo: new FormControl(data.RgNo),
      RollNo: new FormControl(data.RollNo)
    });
  }
 
  getExmFrmList(SnNo){
    const payload = {};
    payload['InCode'] = 13;
    payload['SnNo'] = SnNo;
    payload['OpId'] = sessionStorage.getItem('userId');
    this.umsService.getExmFrmDrpList(payload).subscribe((res) => {
      if (res.status) {
        this.DataList = res.data;
        this.filteredDataList = this.DataList.slice();
       
      } else {
      }
    });
  }
  getList(data) {
    this.List = data;
    this.fetchSubChg()
  }
  fetchSubChg() {
    // this.spinner.show();
    // this.Table = false;
    this.subChgList = [];
    // this.PackingArray = this.PackListForm.get('PackingArray') as FormArray;
    // this.PackingArray.clear();
    let payload = {};
    payload['EcId'] = this.List;
    payload['CgCode'] = this.SubChgForm.value['SubChgClg'] ? this.SubChgForm.value['SubChgClg'] : '';
    payload['Chng'] = this.SubChgForm.value['SubChgChng'] ? this.SubChgForm.value['SubChgChng'] : '';
    payload['Valid'] = this.SubChgForm.value['SubChgValid'] ? this.SubChgForm.value['SubChgValid'] : '';
    this.umsService.fetchSubChgList(payload).subscribe((res) => {
      if (res.status) {
        this.subChgList = res.data;
        // this.Table = true;
        // this.spinner.hide();

      }
      else{
        // this.spinner.hide();
        this.subChgList = [];
      }
    });
   
  }

  edit(k,id){
    if (k === 'true') {
      this.prepopulation(id);
    }
  }


  // prepopulation(data){
  //   this.editButton = true;
  //   this.submitButton = false;
  //   this.deleteButton = false;
    
  // }
  prepopulation(data) {
    this.editButton = true;
    this.submitButton = false;
    this.deleteButton = false;
  
    this.SubChgForm = this.fb.group({
      EcId: new FormControl(data.EcId),
      Batch: new FormControl(data.Batch),
      RgNo: new FormControl(data.RgNo),
      RollNo: new FormControl(data.RollNo)
    });
  }
  
  // prepopulation(id) {
  //   this.spinner.show();
  //   const payload = {};
  //   payload['EcId'] = id.EcId;
  //   this.umsService.fetchSubChgList(payload).subscribe((res) => {
  //     this.spinner.hide();
  //     const data = res.data[0];
  //     if (res.status){
  //        this.editButton = true;
  //       //  this.isreaddelete = false;
  //        this.submitButton = false;
  //       //  this.isread = true;
  //        this.deleteButton  = false;
  //        this.SubChgForm = this.fb.group({
  //         EcId: new FormControl (data.EcId),
  //         Batch: new FormControl (data.Batch),
  //         RgNo: new FormControl(data.RgNo),
  //         RollNo : new FormControl(data.RollNo)
  //       });
  //      }else{
         
  //      }
  //    });
  // }

  addnewrecord(e){
    if (e === 'true'){
      this.editButton = false;
      this.submitButton = true;
      this.deleteButton = false;
       this.SubChgForm.reset();
    } 
    else {
      this.editButton = true;
      this.submitButton = false;
      this.deleteButton = true;
        this.ngOnInit();
    }
  }


  submit(){
    if (this.SubChgForm.invalid) {
      
      return;
    } else {
      this.submitSubChg();
    }
  }
  // submitEnrollment() {
  //   this.submitpayload = this.SubChgForm.value;
  // }
  submitSubChg() {
    this.spinner.show();
    this.submitpayload = this.SubChgForm.value;
    let payload = {}
    payload['EcId'] = this.List
    payload['RollNo'] = 0
    payload['RgNo'] = this.submitpayload.RgNo
    payload['Batch'] = ''
    this.umsService.saveSubChg(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status){
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        
      } else {
        this.spinner.hide();
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      
    });
  }

  delete(){
   this.DeletetheRecord();
  }
  DeletetheRecord(){
    const  data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes'){
        this.deletedata(this.SubChgForm.value);
        // this.dialogRef2.close();
      }else{
        // this.dialogRef2.close();
      }
    });
   }
   deletedata(id){
    this.spinner.show();
    const options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),  body: {
      EcId: this.List,
      Batch: id.Batch,
      RgNo: id.RgNo,
      RollNo: id.RollNo
    },
  };
    this.httpClient.delete(this.APIService + '/inputs/EditSubChng', options)
    .subscribe((s) => {
      this.spinner.hide();
      let cc = [];
      cc.push(s);
      let  data = {}
      data['message'] = cc[0].message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
      // this.dialogRef.afterClosed().subscribe((result) => {
      //   // this.dialogRef2.close();
      // });
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
      // this.dialogRef.afterClosed().subscribe((result) => {
      //   // this.dialogRef2.close();
      // });
   });

   }

  update(){
    if (this.SubChgForm.invalid) {
      
      return;
    } else {
      this.updateSubChg();
    }
  }

  // updateEnrollment(){

  // }
  updateSubChg() {
    this.spinner.show();
    this.editButton = true;
    this.submitButton = false;
    this.deleteButton = false;
    this.submitpayload = this.SubChgForm.value;
    let payload = {}
    payload['EcId'] = this.List
    payload['RollNo'] = this.submitpayload.RollNo
    payload['RgNo'] = this.submitpayload.RgNo
    payload['Batch'] = this.submitpayload.Batch
    this.umsService.updateSubChg(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status){
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
      } else {
        this.spinner.hide();
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let  data = {} 
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
    });
  }
  getCollegeData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();
    
    },(ERROR: HttpErrorResponse) => {
      this.collegeList = [];
      this.spinner.hide();
    })
  }

}
